import { SortStowageColumnEnum } from 'src/enums/stowage/sortStowageColumnEnum';
import { OperationListColumns } from 'src/types/ViewModel/Stowage/OperationListColumns';
import { applyColumnOrder } from './columnOrderUtils';

export interface ColumnConfig {
    id: string;
    label: string;
    defaultFlex: string;
    cssClass?: string;
    sortEnum?: SortStowageColumnEnum;
    isTextLeft?: boolean;
    isNumeric?: boolean;
    columnVisibilityKey?: keyof OperationListColumns; // Changed to keyof OperationListColumns
}

export const operationListColumnConfigs: ColumnConfig[] = [
    {
        id: 'statusIcon',
        label: 'Status',
        defaultFlex: '135',
        cssClass: 'col-menu status-icon',
    },
    {
        id: 'operationType',
        label: 'Type',
        defaultFlex: '80',
        cssClass: 'col-ops',
        sortEnum: SortStowageColumnEnum.OperationType,
    },
    {
        id: 'cargoNr',
        label: 'Cargo #',
        defaultFlex: '110',
        cssClass: 'col-cargo-nr',
        sortEnum: SortStowageColumnEnum.CargoNr,
    },
    {
        id: 'tradeName',
        label: 'Trade name',
        defaultFlex: '350',
        cssClass: 'col-trade-name',
        isTextLeft: true,
        sortEnum: SortStowageColumnEnum.TradeName,
        columnVisibilityKey: 'showTradeName',
    },
    {
        id: 'productName',
        label: 'Product name',
        defaultFlex: '250',
        cssClass: 'col-trade-name',
        isTextLeft: true,
        sortEnum: SortStowageColumnEnum.ProductName,
        columnVisibilityKey: 'showProductName',
    },
    {
        id: 'nominatedWeight',
        label: 'Nom. weight',
        defaultFlex: '120',
        cssClass: 'col-nom col-right',
        isNumeric: true,
        sortEnum: SortStowageColumnEnum.NominatedWeight,
        columnVisibilityKey: 'showNominatedWeight',
    },
    {
        id: 'nominatedVolume',
        label: 'Nom. volume',
        defaultFlex: '120',
        cssClass: 'col-nom col-right',
        isNumeric: true,
        sortEnum: SortStowageColumnEnum.NominatedVolume,
        columnVisibilityKey: 'showNominatedVolume',
    },
    {
        id: 'notStowedWeight',
        label: 'Not stowed (MT)',
        defaultFlex: '120',
        cssClass: 'col-stowed highlight',
        isNumeric: true,
        sortEnum: SortStowageColumnEnum.NotStowedWeight,
        columnVisibilityKey: 'showNotStowedWeight',
    },
    {
        id: 'notStowedVolume',
        label: 'Not stowed (m³)',
        defaultFlex: '120',
        cssClass: 'col-stowed highlight',
        isNumeric: true,
        sortEnum: SortStowageColumnEnum.NotStowedVolume,
        columnVisibilityKey: 'showNotStowedVolume',
    },
    {
        id: 'stowedWeight',
        label: 'Stowed (MT)',
        defaultFlex: '120',
        cssClass: 'col-stowed',
        isNumeric: true,
        sortEnum: SortStowageColumnEnum.StowedWeight,
        columnVisibilityKey: 'showStowedWeight',
    },
    {
        id: 'stowedVolume',
        label: 'Stowed (m³)',
        defaultFlex: '120',
        cssClass: 'col-stowed',
        isNumeric: true,
        sortEnum: SortStowageColumnEnum.StowedVolume,
        columnVisibilityKey: 'showStowedVolume',
    },
    {
        id: 'charterer',
        label: 'Charterer',
        defaultFlex: '150',
        cssClass: 'col-trade-name',
        isTextLeft: true,
        columnVisibilityKey: 'showCharterer',
    },
    {
        id: 'contractWeight',
        label: 'Cont. weight',
        defaultFlex: '120',
        cssClass: 'col-right',
        isNumeric: true,
        columnVisibilityKey: 'showContractWeight',
    },
    {
        id: 'totalCargoNominatedWeight',
        label: 'Total nom. weight',
        defaultFlex: '200',
        cssClass: 'col-nom col-right',
        isNumeric: true,
        columnVisibilityKey: 'showTotalCargoNominatedWeight',
    },
    {
        id: 'billOfLading',
        label: 'Bill of lading',
        defaultFlex: '120',
        cssClass: 'col-right',
        isNumeric: true,
        columnVisibilityKey: 'showBillOfLadingFigure',
    },
    {
        id: 'shipFigure',
        label: 'Ship figure',
        defaultFlex: '120',
        cssClass: 'col-right',
        isNumeric: true,
        columnVisibilityKey: 'showShipFigure',
    },
    {
        id: 'option',
        label: 'Option',
        defaultFlex: '100',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showOption',
    },
    {
        id: 'swingWeights',
        label: 'Total nom./swing weights',
        defaultFlex: '200',
        cssClass: 'col-tot-nom col-right',
        isNumeric: true,
        columnVisibilityKey: 'showSwingWeights',
    },
    {
        id: 'swingVolumes',
        label: 'Total nom./swing volume',
        defaultFlex: '200',
        cssClass: 'col-tot-nom col-right',
        isNumeric: true,
        columnVisibilityKey: 'showSwingVolumes',
    },
    {
        id: 'litreWeight',
        label: 'Litre weight',
        defaultFlex: '120',
        cssClass: 'col-right',
        isNumeric: true,
        columnVisibilityKey: 'showLitreWeight',
    },
    {
        id: 'heating',
        label: 'Heating',
        defaultFlex: '100',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showHeating',
    },
    {
        id: 'maxAdjacentTemp',
        label: 'Max adj. temp.',
        defaultFlex: '130',
        cssClass: 'col-right',
        isNumeric: true,
        columnVisibilityKey: 'showMaxAdjacentTemp',
    },
    {
        id: 'flashPoint',
        label: 'Flash point',
        defaultFlex: '120',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showFlashPoint',
    },
    {
        id: 'meltingPoint',
        label: 'Melting point',
        defaultFlex: '120',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showMeltingPoint',
    },
    {
        id: 'boilingPoint',
        label: 'Boiling point',
        defaultFlex: '120',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showBoilingPoint',
    },
    {
        id: 'tankNames',
        label: 'Tanks',
        defaultFlex: '150',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showTankNames',
    },
    {
        id: 'ports',
        label: 'Load - Unload Port',
        defaultFlex: '350',
        cssClass: 'col-ports',
        sortEnum: SortStowageColumnEnum.PortNames,
        columnVisibilityKey: 'showPorts',
    },
    {
        id: 'uscgGroupNumber',
        label: 'USCG #',
        defaultFlex: '100',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showUscgGroupNumber',
    },
    {
        id: 'pollution',
        label: 'Pollution',
        defaultFlex: '100',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showPollution',
    },
    {
        id: 'shipType',
        label: 'Ship type',
        defaultFlex: '100',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showShipType',
    },
    {
        id: 'envControl',
        label: 'Env. Control',
        defaultFlex: '130',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showEnvironmentControl',
    },
    {
        id: 'source',
        label: 'Source',
        defaultFlex: '100',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showSource',
    },
    {
        id: 'contractStatus',
        label: 'Contract status',
        defaultFlex: '130',
        cssClass: 'text-left',
        isTextLeft: true,
        columnVisibilityKey: 'showContractStatus',
    },
];

export const getColumnConfigById = (id: string): ColumnConfig | undefined => {
    return operationListColumnConfigs.find((config) => config.id === id);
};

export const getColumnConfigBySortEnum = (sortEnum: SortStowageColumnEnum): ColumnConfig | undefined => {
    return operationListColumnConfigs.find((config) => config.sortEnum === sortEnum);
};

export const getVisibleColumns = (operationListColumns: OperationListColumns | null | undefined): ColumnConfig[] => {
    // Always include statusIcon, operationType, and cargoNr
    const alwaysVisibleColumnIds = ['statusIcon', 'operationType', 'cargoNr'];

    if (!operationListColumns) {
        return operationListColumnConfigs.filter((column) => alwaysVisibleColumnIds.includes(column.id));
    }

    return operationListColumnConfigs.filter((column) => {
        if (alwaysVisibleColumnIds.includes(column.id)) return true;
        if (!column.columnVisibilityKey) return false;

        // Use type assertion to access property safely
        return operationListColumns[column.columnVisibilityKey] === true;
    });
};

export const getOrderedVisibleColumns = (operationListColumns: OperationListColumns | null | undefined): ColumnConfig[] => {
    return applyColumnOrder(getVisibleColumns(operationListColumns));
};
